module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Antony F. Campbell\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_c('BR'), _c('B', [_vm._v("Antony F. Campbell, SJ")]), _vm._v(", (1934–2020) was professor of Old Testament at Jesuit Theological College, Parkville, Australia. His other books include "), _c('I', [_vm._v("Joshua to Chronicles: An Introduction, God First Loved Us: The Challenge of Accepting Unconditional Love")]), _vm._v(", and "), _c('I', [_vm._v("The Whisper of Spirit: A Believable God Today.")])], 1)]), _vm._v(" "), _vm._m(2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/zzw7mk/tc-custom/9781467433204.jpg?1730409504296",
      "alt": "This image is the cover for the book 1 Samuel, The Forms of the Old Testament Literature (FOTL)"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("1 Samuel, The Forms of the Old Testament Literature (FOTL)\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v(" Antony Campbell’s valuable form-critical analysis of 1 Samuel highlights both the literary development of the text itself and its meanings for its audience. A skilled student of the Hebrew Scriptures and their ancient context, Campbell shows modern readers the process of editing and reworking that shaped 1 Samuel’s final form. As Campbell’s study reveals, the tensions and contradictions that exist in the present text reflect a massive change in the way of life of ancient Israel. Samuel, the first prophet, here emerges to preside over the rise of Saul, Israel’s first king, to be the agent of Saul’s rejection, and to anoint David as Israel’s next king and the first established head of a royal dynasty. The book of 1 Samuel captures the work of God within this interplay of sociopolitical forces, and Campbell fruitfully explores the text both as a repository of traditions of great significance for Israel and as a paradigm of Israel’s use of narrative for theological expression. ")]), _vm._v(" "), _c('p')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Wm. B. Eerdmans Publishing Co.\n   ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0